import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MicrositePreview from "./MicrositePreview";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:orgId/:eventId" element={<MicrositePreview />} />
        <Route path="*" element={<h2>404 - Microsite Not Found</h2>} />
      </Routes>
    </Router>
  );
}

export default App;